import { Component, OnInit } from '@angular/core';
import {LoggerService} from '../logger.service';
import {WizardService} from '../wizard/wizard.service';
import {AddressModel} from '../model/address.model';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent implements OnInit {

  public get address(): AddressModel {
    return this.wizard.getAddress();
  }

  constructor(
    private wizard: WizardService,
    private logger: LoggerService
  ) {

  }

  ngOnInit() {
  }

}
